/* ==========================================================================
   KOVA STORE — Interactions
   Load with: {{ 'kova-interactions.js' | asset_url | script_tag }}
   ========================================================================== */

(function () {
  const overlay = document.getElementById('kova-qa-overlay');
  const drawer = document.getElementById('kova-qa-drawer');
  if (!overlay || !drawer) return;

  const titleEl = document.getElementById('kova-qa-title');
  const priceEl = drawer.querySelector('.kova-qa-drawer__price');
  const closeBtn = document.getElementById('kova-qa-close');
  const continueBtn = document.getElementById('kova-qa-continue');

  function openDrawer(title, price) {
    titleEl.textContent = title;
    priceEl.textContent = price;
    overlay.hidden = false;
    drawer.hidden = false;
    requestAnimationFrame(() => {
      overlay.classList.add('is-visible');
      drawer.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => {
      overlay.hidden = true;
      drawer.hidden = true;
    }, 400);
  }

  closeBtn.addEventListener('click', closeDrawer);
  continueBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Delegate clicks so this works for cards rendered after page load (e.g. infinite scroll)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    const title = btn.dataset.productTitle || 'Producto';
    const price = btn.dataset.productPrice || '';

    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('No se pudo agregar el producto');

      document.dispatchEvent(new CustomEvent('kova:cart:add', { detail: { variantId } }));
      openDrawer(title, price);
    } catch (err) {
      console.error('[Kova] Error al agregar al carrito:', err);
      openDrawer(title, 'No se pudo agregar — intenta de nuevo');
    } finally {
      btn.disabled = false;
    }
  });
})();
